



































import { Component, Vue } from 'vue-property-decorator'
import { logout } from '@/utils/http-client/auth-api'
import UserBus, { User } from '@/utils/buses/UserBus'
import MessageBus from '../utils/buses/MessageBus'

@Component
export default class MyAppBar extends Vue {
  private user: User | null = null

  mounted () {
    // get initial user
    this.user = UserBus.user
    UserBus.$on('user-update', this.onUserUpdate)
  }
  beforeDestroy () {
    // remove event listener to prevent memory leaks
    UserBus.$off('user-update', this.onUserUpdate)
  }

  private onLogClick () {
    if (this.user) {
      logout()
      MessageBus.sendMessage('Successfully logged out', 'success')
    } else {
      this.$router.push({ name: 'login' })
    }
  }

  private onUserUpdate (user: User | null) {
    this.user = user
  }
}
